<template>
    <div class="conference-room h-100 has-text-centered mt-5">
        <div
            class="
                is-flex is-justify-content-center
                has-text-centered
            "
        >           
            <div class="column is-4">
                <article class="box-inicio">
                    <div class="article-top-right has-background-primary p-4">
                        <img
                            src="@/assets/images/user-video.png"
                            :alt="titleMessage"
                            width="80"
                        />
                    </div>
                    <div class="article-content-right p-5">
                        <p class="title is-4 has-text-primary">
                            {{ titleMessage }}
                        </p>
                        <p class="subtitle is-6 mt-6 has-text-greyText">
                            {{ message }}
                        </p>
                    </div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
import { RepositoryFactory } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import * as SignalR from "@microsoft/signalr";

export default {
    name: "survey-online-user",
	computed: {
		...mapGetters("oidcStore", ["oidcIsAuthenticated"])
	},
    data() {
        return {
            id: null,
            surveyId: null,
            environment: null,
            signalRSocket: false,
            titleMessage: "Esperando sala...",
            message: "Por favor espere mientras uno de nuestros operadores le atiende..."
        }
    },
    async beforeDestroy() {
        if (this.id && this.signalRSocket) {
            await this.signalRSocket.invoke(
                "DestroySurveyOnlineUser",
                this.id
            ).catch(err => console.log(err));
        }
    },
    async mounted() {
        await this.signalRInitialize();
        
        if (this.signalRSocket) {
            this.signalRSocket.on("ReceiveSurveyOnlineRoom", this.signalRReceiveSurveyOnlineRoom);
            this.signalRSocket.on("StatusSurveyOnlineRoom", this.signalRStatusSurveyOnlineRoom);
        }
    },
    created() {
        if (this.$route.query.surveyId) {
            this.surveyId = this.$route.query.surveyId;
        }
        if (this.$route.query.environment) {
            this.environment = this.$route.query.environment;
        }

        if (this.surveyId && this.environment) {
            this.setData();
            return;
        }
        
        this.$router.go(-1);
    },
    methods: {
		...mapActions("oidcStore", ["authenticateOidc"]),
        async signalRInitialize() {
            try {
                const socket = new SignalR.HubConnectionBuilder()
                    .withUrl(process.env.VUE_APP_ONLINE_HUB)
                    .withAutomaticReconnect()
                    .build();

                socket.connection.onclose = async (error) => {
                    if (error !== undefined) this.$log(error);

                    this.$log("Reconnecting...");
                    this.signalRSocket = false;
                    await this.signalRInitialize();
                };

                await socket.start();

                this.signalRSocket = socket;
            } catch (err) {
                this.$log("Error, reconnecting...");

                setTimeout(() => {
                    this.signalRInitialize();
                }, 1000);
            }
        },
        async signalRReceiveSurveyOnlineRoom(surveyRoomOnline) {
            window.console.log(surveyRoomOnline)
            if (this.id && surveyRoomOnline.surveyId === this.surveyId) {
                await this.signalRSocket.invoke(
                    "ChangeStatusSurveyOnline",
                    this.id,
                    "Attending",
                    surveyRoomOnline.operatorId
                ).catch(err => window.console.log(err.response));
            }
        },
        async signalRStatusSurveyOnlineRoom(event) {
            window.console.log(event);
            if (event && event.surveyId === this.surveyId && event.status == "Attending") {
                this.$router.push({
                    name: "room",
                    params: { roomId: event.roomId },
                });
            }
        },
        async setData() {
            window.localStorage.removeItem('redirectSurveyOnline');
            if (!this.oidcIsAuthenticated) {
                window.localStorage.setItem('redirectSurveyOnline', window.location.href);
                this.authenticateOidc();
            }
            let payload = {
                surveyId : this.surveyId,
                environment : this.environment
            };
            try {
                var response = await RepositoryFactory.conference.setSurveyOnlineUser(
                    payload
                );

                if (response.status === 200) {
                    this.id = response.data;
                    if (this.signalRSocket) {
                        await this.signalRSocket.invoke(
                            "SurveyOnlineUser",
                            this.id
                        ).catch(err => console.log(err));
                    }
                }
            } catch (error) {
                window.console.log(error.response);
                this.titleMessage = "Error al consultar formulario.";
                this.message = "El registro no fue encontrado, por favor cierra esta pestaña e intente llenar de nuevo el formulario y enviarlo.";
            }
        }
    }
};
</script>